import * as React from "react";
import {
  Box,
  Button,
  Typography,
  Modal,
  TextField,
  FormHelperText,
} from "@mui/material";
import { createnewCategory, createnewPermision } from "../../DAL/create";
import { updateCategory, updatePermision } from "../../DAL/update";
import { useSnackbar } from "notistack";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: "12px",
};

export default function AddCategories({ open, setOpen, Modeltype, Modeldata }) {
  const [name, setName] = React.useState(Modeldata?.name || "");
  const { enqueueSnackbar } = useSnackbar();
  const [description, setDescription] = React.useState(
    Modeldata?.description || ""
  );
  const [type, setType] = React.useState(false);
  const [error, setError] = React.useState("");
  const [id, setid] = React.useState(Modeldata?.id || "");
  React.useEffect(() => {
    setName(Modeldata?.name || "");
    setDescription(Modeldata?.description || "");
    setid(Modeldata?.id || "");
  }, [Modeldata]);

  const handleClose = () => {
    setOpen(false);
    setName("");
    setError("");
    setDescription("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setType(true);
    if (Modeltype === "Add") {
      const resp = await createnewCategory({
        name: name,
        description: description,
      });
      if (resp.status == 400) {
        setError(resp.error);
      } else if (resp?.statusCode == 409) {
        setError(resp.message);
      } else {
        enqueueSnackbar(resp?.data?.message, { variant: "success" });
        handleClose();
      }
    } else {
      const resp = await updateCategory(id, {
        name: name,
        description: description,
      });
      if (resp.status == 400) {
        enqueueSnackbar(resp.error, { variant: "error" });
      } else if (resp?.statusCode == 400) {
        setError(resp?.message);
      } else {
        enqueueSnackbar("Category updated successfully", {
          variant: "success",
        });
        handleClose();
      }
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
      BackdropProps={{
        sx: {
          backdropFilter: "blur(4px)",
          backgroundColor: "rgba(0, 0, 0, 0.2)",
        },
      }}
    >
      <Box sx={style}>
        <Typography id="modal-title" variant="h6" component="h2">
          {Modeltype} Product Category
        </Typography>
        <TextField
          sx={{ marginTop: "10px", borderRadius: "6px" }}
          fullWidth
          required
          label="Category Name"
          variant="outlined"
          name="name"
          value={name}
          inputProps={{ maxLength: 15 }}
          onChange={(e) => {
            setName(e.target.value);
            if (error) setError("");
          }}
        />

        <FormHelperText sx={{ color: "red" }}>{error}</FormHelperText>
        <TextField
          sx={{ marginTop: "10px", borderRadius: "6px" }}
          fullWidth
          label="Description"
          variant="outlined"
          name="permission"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
        <Box
          sx={{
            display: "flex",
            gap: 2,
            justifyContent: "flex-end",
            marginTop: "10px",
          }}
        >
          <Button
            type="button"
            variant="contained"
            sx={{ backgroundColor: "#B1B1B1", textTransform: "none" }}
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            type="submit"
            variant="contained"
            className="gradientButton"
            sx={{ textTransform: "none" }}
            disabled={!name.trim()}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
